import { useAuthStore } from "../stores/authStore";

export const fetchWithHeaders = async (
	url: string,
	options: RequestInit = {}
): Promise<Response> => {
	const token = useAuthStore.getState().token;
	let csrf_token: any = "";
	function getCookie(name: string) {
		const value = `; ${document.cookie}`;
		const parts: any = value.split(`; ${name}=`);
		if (parts.length === 2) return parts?.pop().split(";").shift();
		return null;
	}

	// Get the CSRF token from the cookie
	csrf_token = getCookie("csrf_token");
	// check if csrf_token is defined if not defined call fetch user identity api first.
	if (
		(options.method === "POST" || options.method === "PUT" || options.method === "DELETE") &&
		csrf_token === ""
	) {
		csrf_token = getCookie("csrf_token");
	}

	// Determine if the request body is FormData
	const isFormData = options.body instanceof FormData;
	const headers: Record<string, string> = {
		...(isFormData ? {} : { "Content-Type": "application/json" }),
		...(token ? { Authorization: `Bearer ${token}` } : {}),
		...(options.method === "POST" || options.method === "PUT" || options.method === "DELETE"
			? { "X-CSRF-Token": String(csrf_token) }
			: {}),
		...(options.headers as Record<string, string>), //for extra headers
	};


	const response = await fetch(url, {
		...options,
		credentials: "include", // ensure cookies are sent
		headers: {
		  ...(options.headers || {}),
		  ...headers,
		},
	});
		if (!response.ok) {
			if (response.status === 401 || response.statusText === "Unauthorized") {
				localStorage.clear();
				if (typeof window !== "undefined") {
					window.location.href = "/login";
				}
			}
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	return response;
};
